import React from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

const CommonBtn = () => {
  return (
    <div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width:"100%",
    }}
  >
    <div
      className="contact"
      style={{
        margin:"20px 0px",
        width: "100%",
        display: "flex",
        justifyContent: "space-evenly",
        flexWrap:"wrap"
      }}
    >
      {/* phone div */}
      <a
        href="tel:+918888769628"
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div
          className="contactdiv Contactus_div"
          style={{
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            marginBottom: "10px",
            borderRadius: "10px",
          
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom:"10px"
            }}
          >
            

            <PhoneIcon
              sx={{
                fontSize: 40,
                margin: "5px",
                marginRight:"10px",
              }}
            />
            <h1 style={{fontSize:"28px"}}>Call Us</h1>
          </div>
        </div>
      </a>
      {/* whatsapp div */}
      <a
        href="https://wa.me/8888769628"
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div
          className="whatsupdiv Contactus_div"
          style={{
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            marginBottom: "10px",
            borderRadius: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
               marginBottom:"10px"
            }}
          >
           

            <WhatsAppIcon
              sx={{
                fontSize: 40,
                margin: "5px",
                color: "white",
                marginRight:"10px",
                backgroundColor:"green",
                borderRadius:"30%",
                "&:hover": {  cursor: "pointer" },
              }}
            />
             <h1 style={{fontSize:"28px"}}>Whatsapp Us</h1>
          </div>
        </div>
      </a>

      {/* email div */}
      <a
        href="mailto:faisalsk8484@gmail.com"
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div
          className="emaildiv Contactus_div"
          style={{
            marginBottom: "10px",
            borderRadius: "10px",
            display:"flex",
            alignItems:"center",
            justifyContent:"center"
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
               marginBottom:"10px"
            }}
          >
           

            <EmailIcon
              sx={{
                fontSize: 40,
                margin: "5px",
                marginRight:"10px",
              }}
            />
             <h1 style={{fontSize:"28px"}}>Email Us</h1>
          </div>
        </div>
      </a>
    </div>
  </div>
  );
};

export default CommonBtn;
